import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import courierImg from "../../../../assets/imgs/services/nationals/courier.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function Courier() {
  const [tCourier] = useTranslation("courierPage");
  const [tSMetaData] = useTranslation("metaData");
  const idCourier = "407138e3-da91-4725-b44e-ce97858a0fc3";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[2]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[2]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idCourier}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("mensajería.title")}</title>
        <meta
          name="description"
          content={tSMetaData("mensajería.description")}
        />
      </Helmet>
      <ImageHeader
        section={tCourier("header.section")}
        title={tCourier("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tCourier("description.content"))
        }
        quoteBtn={tCourier("header.quote-btn")}
        quoteProductID="btnQuoteCourier"
        contactSales={tCourier("header.contact-sales")}
        contactProductID="btnContactCourier"
        imgBackground={courierImg}
      />
      <Accordion
        title={tCourier("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tCourier("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tCourier("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tCourier("accordion-2.content"))
        }
      />
    </>
  );
}

export default Courier;
